import { fromJS } from 'immutable';

import {
	BusinessQuery,
	FilterQueryType,
	List,
	Location
} from '@/modules/dashboard/dashboardTypes';

import { User } from '@/modules/user/userTypes';

const resetQuery = (
	query: BusinessQuery,
	locationSelected: Location,
	listSelected: List,
	user?: User
): BusinessQuery => {
	const queryNew: BusinessQuery = fromJS(query).toJS();

	queryNew.minDistance = 0;

	queryNew.maxDistance = locationSelected?.radius ?? 40;

	delete queryNew.minYelpReviews;

	delete queryNew.maxYelpReviews;

	delete queryNew.searchName;

	delete queryNew.searches;

	delete queryNew.chains;

	delete queryNew.nonChains;

	delete queryNew.includeEmailsYes;

	delete queryNew.includeEmailsNo;

	delete queryNew.includeWebsite;

	delete queryNew.includeWebsitesYes;

	delete queryNew.includeWebsitesNo;

	delete queryNew.includeFBMessenger;

	delete queryNew.includeIGMessenger;

	delete queryNew.includePhoneNumber;

	delete queryNew.includePOIs;

	delete queryNew.excludePOIs;

	delete queryNew.haveRE2;

	delete queryNew.scheduledYes;

	delete queryNew.scheduledNo;

	delete queryNew.contactedYes;

	delete queryNew.contactedNo;

	delete queryNew.lead;

	delete queryNew.notesSaved;

	delete queryNew.countOne;

	delete queryNew.countTwoTen;

	delete queryNew.countTenPlus;

	delete queryNew.employees1To49;

	delete queryNew.employees50To99;

	delete queryNew.employees100To249;

	delete queryNew.employees250To499;

	delete queryNew.employeesOver500;

	delete queryNew.salesVolumeLessThan5M;

	delete queryNew.salesVolume5To10M;

	delete queryNew.salesVolume10To20M;

	delete queryNew.salesVolume20To50M;

	delete queryNew.salesVolume50To100M;

	delete queryNew.salesVolumeOver100M;

	delete queryNew.sqrFeetSmall;

	delete queryNew.sqrFeetMedium;

	delete queryNew.sqrFeetLarge;

	delete queryNew.sqftSmall;

	delete queryNew.sqftMedium;

	delete queryNew.sqftLarge;

	delete queryNew.selectedLocation;

	delete queryNew.includes;

	delete queryNew.excludes;

	delete queryNew.sort;

	if (locationSelected?.location && !queryNew.coordinates) {
		delete queryNew.listId;

		delete queryNew.coordinates;

		queryNew.coordinates = JSON.stringify(
			locationSelected?.location?.coordinates
		);
	} else if (locationSelected?.location && queryNew.coordinates) {
		queryNew.coordinates = JSON.stringify(
			locationSelected?.location?.coordinates
		);

		queryNew.queryType = FilterQueryType.LOCATION;
	} else if (listSelected?.businessIds && !queryNew.listId) {
		delete queryNew.listId;

		delete queryNew.coordinates;

		queryNew.queryType = FilterQueryType.LIST;
	}

	if (!queryNew.count) {
		queryNew.count = true;
	}

	queryNew.limit = 50;

	queryNew.skip = 0;
	return queryNew;
};

export default resetQuery;
